export default __webpack_public_path__ + "static/0245-0ef91ac072473f7b7e0e921f49ce831d.png";